import React, {useContext, useEffect, useState } from 'react'
import './Form.css'
import Field from '../Field/Field'
import Pill from '../Pill/Pill'
import {serverTimestamp } from 'firebase/firestore'
import Notif from '../Notif/Notif'

import PlaceHolderFile from '../../Assets/PlaceHolderFile.svg'

import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  listAll,
} from "firebase/storage";
import { storage } from '../../firebase/firebase'
import { v4 } from 'uuid'

import { DashboardContext } from '../../Hooks/DashboardContext'
import { AddDoc, UpdateDoc} from '../../firebase/utils'

import ColorPicker from '../ColorPicker/ColorPicker'
import SelectOption from '../SelectOption/SelectOption'
import DeleteButton from '../DeleteButton/DeleteButton'
import { useNavigate } from 'react-router-dom'
import Stars from '../Stars/Stars'






const Form = () => {

  const Template=[
    { 
      CategorieName:'Electronique',
      souscategorie:['Accessoires','Telephone','TV'],
    },
    { 
      CategorieName:'Vêtements',
      souscategorie:['Homme','Femme','Garçon','Fille'],
      Taille:['XS','S',"M",'L','XL','XXL']
    },
    { 
      CategorieName:'Beauté',
      souscategorie:['Perruque','Parfums','Lotion','Pommade','Savon'],
    },
    { 
      CategorieName:'Jeu',
      souscategorie:['Perruque','Parfums','Lotion','Pommade','Savon'],
    }
  ]


  const Options1=['Electronique','Vêtements','Beauté']
  const Options2=['Homme','Femme','Garçon','Fille']
  const Options3=['XS','S',"M",'L','XL','XXL']

  const Options4=['5%','10%',"15%",'50%','75%','95%']


 
  const NavigateTo=useNavigate()


  const [Nom,setNom]=useState('')
  const [SKU,setSKU]=useState('')
  const [Description, setDescription] = useState('')
  const [EtatDuProduit, setEtatduProduit] = useState('')
  const [Quantite, setQuantite] = useState('')
  const [PrixVendeur, setPrix] = useState('')
  const [PrixInApp, setPrixInApp] = useState('')
  const [TauxDeMarge, setTauxDeMarge] = useState('')
  const [ajoutable,setajoutable]=useState(false)


  


 

  
  const [Categorie,setCategorie]=useState('')
  const [Categories,setCategories]=useState([])
  const Categ=Categories

  const [prod,setProd]=useState(null)
  const [ImgVignette,setImgVignette]=useState(null)
  const [Imgs,setImgs]=useState(null)


  const [files,setFiles] = useState(null);
  const [Urls,setUrls]=useState(null)

  const [SKUcode,setSKUcode]=useState('SKU Code')
  const [PrevName,setPrevName]=useState(null)

  const [starnumb,setStarnumb]=useState(0)

  const {loading,setloading,currentProduct,setcurrentProduct,setproduit,Message,setMessage,idProduct,setidProduct}=useContext(DashboardContext)


 
  useEffect(()=>{
      //if (currentProduct===null) return
      setProd(currentProduct)
      if (currentProduct===null) return
      setPrevName(currentProduct.Nom)
      
      setCategories(currentProduct.Categories)
      
    // if (prod!==null&&typeof(prod.Categories)!=='undefined') {
    //   //setCategories(prod.Categories)
    //   console.log(prod.Categories)
    // }

  },[currentProduct])


 

  function SKUgenerator(codeSKU) {
      const Details={nom:'Samsung S25',couleurs:'Blanc',taille:'64GB',ram:'8GB',Processeur:'Exynos SnapDragon Elite 8 Gen 2'}


    //const codeSKU=Details
    //const DetailsString=[]
    const DetailsString=[codeSKU.Nom,codeSKU.PrixInApp,codeSKU.Categorie,codeSKU.EtatDuProduit]

    /*for (const key in codeSKU) {
   
      DetailsString.push(codeSKU[key])
  
    }*/

     const Tab=DetailsString.toString().split(' ').toString().split(',')

   
    const initialLetter=Tab.map((initial)=>{return(initial.slice(0,4))})

    const concatText=initialLetter.join('-')

    const uppercase=concatText.toUpperCase()/**/

    setSKUcode(uppercase)
    setSKUcode(v4().slice(0,15))

  }

  const ProductsList=()=>{
    NavigateTo('../ProductsMenu/Products')
    setcurrentProduct(null)

}

function setRating(e) {
  const indexStar=e.currentTarget.getAttribute('index')
  setStarnumb(indexStar)
  AddProdDetail(['Rates'],e.currentTarget.getAttribute('index'))

  
}

 function BatchUpload (e,valideWidth,valideHeight) {
    
    const Files=e.currentTarget.files
    const DeleteButtons =e.currentTarget.parentNode.parentNode.parentNode.querySelectorAll('.delete')
    const GoodImg=Array(4).fill(undefined)

    for (let index = 0; index < DeleteButtons.length; index++) {
      
      DeleteButtons[index].classList.add('hide')
     
    }
   
  
    for (let index = 0; index < Files.length; index++) {
      const ComparedImage=new Image()

      ComparedImage.onload=()=>{
        if(ComparedImage.width===valideWidth && ComparedImage.height===valideHeight) {

          //setImgs(Files)
          DeleteButtons[index].classList.remove('hide')
          GoodImg[index]=Files[index]
          setImgs([...GoodImg])
          document.querySelector('#Uploader2').value=''
          
        }
        else {
          
          console.log(`La  ${index+1}ème image est pas au bon format`) 
          DeleteButtons[index].classList.add('hide')
          setImgs(null)

          setMessage(`La  ${index+1}ème image est pas au bon format`)
          //console.log(ErrorMessage)

          document.querySelector('#ErrorDial').showModal()
          //document.querySelector('#Uploader2').value=''
          
        }
      }
      ComparedImage.src=URL.createObjectURL(Files[index])
      
      
    }
    
  }
 
  function UpdateImgs (index,e,valideWidth,valideHeight) {
    
    const File=e.currentTarget.files
    const DelButton=e.currentTarget.parentNode.querySelector('.delete')
    
 
    const ComparedImage=new Image();

    ComparedImage.onload=()=>{

      if (ComparedImage.width===valideWidth && ComparedImage.height===valideHeight) {
        if (Imgs===null) {
  
          const TabImgs=Array(4).fill(undefined)
          const UpdatedImgsSingle= TabImgs.map((img,i)=>{
            if(i===index) {
              
              return img=File[0];
              ;
            }
            else {
              return img
            }
          })
          setImgs(UpdatedImgsSingle)
        
        }
        else {
      
        const UpdatedImgs =[...Imgs].map((img,i) => {
          if (i===index) {
      
            return img=File[0];
      
            } else {
      
           return img;
          }
          });
      
          
          
          setImgs(UpdatedImgs);
      
        }
        DelButton.classList.remove('hide')
        document.querySelector(`#Img${index}`).value=''
      }
      else
      {
        setMessage(`L'image ${index+1} est pas au bon format`)
        document.querySelector('#ErrorDial').showModal()
        DelButton.classList.add('hide')
        document.querySelector(`#Img${index}`).value=''
       
        //setImgs(null)
      
      }

   
    }
    
    ComparedImage.src=URL.createObjectURL(File[0])
  }
  
  function DeletePicture(e,index) {
    
    const DeleteButton=e.currentTarget
    DeleteButton.classList.add('hide')
    document.querySelector(`#Img${index}`).value=''


    if (Imgs===null) return
    else {
  
     const DeletedTab=[...Imgs].map((img,idx)=>{
        if (idx===index) {
          return img=undefined
        }
        else {
          return img
        }
        })

      setImgs(DeletedTab)
    }
   
  }
  function UploadVignette (e,valideWidth,valideHeight) {
    
    const DeleteButton=e.currentTarget.parentNode.parentNode.parentNode.querySelector('.delete')
    const ImgCurent=e.currentTarget.files
    const ComparedImage=new Image()
    ComparedImage.onload=()=>{
      if (ComparedImage.width===valideWidth && ComparedImage.height===valideHeight) {

        DeleteButton.classList.remove('hide')
        setImgVignette(ImgCurent[0])
        
      } else {
         document.querySelector('#ErrorDial').showModal()
         setMessage('Vignette au mauvais format')
        
        document.querySelector('#Uploader').value=''

        
      }


    }

    ComparedImage.src=URL.createObjectURL(ImgCurent[0])

    
   
   
  }

  function DeleteVignette (e) {
    
    const DeleteButton=e.currentTarget

    DeleteButton.classList.add('hide')

    DeleteButton.parentNode.parentNode.querySelector('#Uploader').value=''
    setImgVignette(null)

    
  }

  const AddProdDetail=async(key,valeur)=>{
    
    setProd((prevstate)=>({...prevstate,[key]:valeur,
      createdAt: serverTimestamp(),Categories:Categ}))
    //setFiles([ImgVignette,...Imgs])
    
    
  }


  const AddtoTheDatabase= async ()=>{
    if(prod===null) {
      setMessage("Le formulaire n'est pas bien rempli")
      document.querySelector('#ErrorDial').showModal()
    }
    else{

      AjouterUnProduit() 
      /** 
      if (canSend) {
        setcanSend(false)
        
      } else {

        setcanSend(true)
        
      }*/

    }
   

  }
 /* const UpdatetoTheDatabase= async ()=>{
    const DownloadUrls=[]
 
    const AjouterUnProduit= async ()=>{

    const  UpdateUrlsImgs=async (Urls)=>{
      setUpdatedUrlsImages(Urls)
      return UpdatedUrlsImages
    }
      
      const imageFolderRef=ref(storage,`Produits/${PrevName}/`)
      let ImagesRef=null

        if (imageFolderRef!==null) {
            
            ImagesRef=await listAll(imageFolderRef)
            
            ImagesRef.items.forEach(
              (imgRef)=>{
                deleteObject(imgRef)
              }
            )

        }
     
         if(prod===null)  {
          setMessage("Aucune champ n'est ajouté")
          document.querySelector('#ErrorDial').showModal()
          return
        }   
         if(files==null) {
          
          setMessage("Aucune Image n'est ajouté")
          document.querySelector('#ErrorDial').showModal()
          return
        }
  
        setloading(true); 

        [...files].forEach(
              
              async img => {

                const imageRef = ref(storage, `Produits/${prod.Nom}/${prod.Nom + v4()}`);
                const snapshot= await uploadBytes(imageRef, img)
                const url= await getDownloadURL(snapshot.ref)

                getDownloadURL(snapshot.ref).then(
                  (url)=>{

                    DownloadUrls.push(url)
                    setUpdatedUrlsImages((urlprev)=>[...urlprev,url])


                  }
                )


                
                //DownloadUrls.push(url)
                //setUpdatedUrlsImages((urlprev)=>[...urlprev,url])
                //UpdateUrlsImgs(DownloadUrls)

               
                

              }
        )
        
       
        

      
    }

   
    if (prod===null) return

    await AjouterUnProduit().then(()=>{

      UpdateDoc('Produits',idProduct,{...prod,'UrlsImages':UpdatedUrlsImages}).then(()=>setloading(false))
      
    
    })
  
   
    

   
    

    ResetForm()
    
    setMessage("Le produit a bien été mis à jour")
    document.querySelector('#ErrorDial').showModal()
   
  }
  */

  const UpdatetoTheDatabase = async () => {
    if (!prod) {
      setMessage("Aucun champ n'est ajouté");
      document.querySelector('#ErrorDial').showModal();
      return;
    }
  
    if (!files || files.length === 0) {
      setMessage("Aucune image n'est ajoutée");
      document.querySelector('#ErrorDial').showModal();

      
      setMessage("Vous allez donc conservez les anciennes images");
      document.querySelector('#ErrorDial').showModal();

      
      // Mise à jour de la base de données
      await UpdateDoc('Produits', idProduct,prod);
  
      // Message de succès
      ResetForm();
      setMessage("Le produit a bien été mis à jour");
      document.querySelector('#ErrorDial').showModal();
      return;
    }
  
    setloading(true);
  
    try {
      // Supprimer les anciennes images si elles existent
      const oldImagesFolderRef = ref(storage, `Produits/${PrevName}/`);
      const oldImagesList = await listAll(oldImagesFolderRef);
  
      await Promise.all(
        oldImagesList.items.map(imgRef => deleteObject(imgRef))
      );
  
      // Upload des nouvelles images
      const uploadedUrls = await Promise.all(
        [...files].map(async (img) => {
          const imageRef = ref(storage, `Produits/${prod.Nom}/${prod.Nom + v4()}`);
          const snapshot = await uploadBytes(imageRef, img);
          const url = await getDownloadURL(snapshot.ref);
          return url;
        })
      );
  
      // Mise à jour de la base de données
      await UpdateDoc('Produits', idProduct, {
        ...prod,
        UrlsImages: uploadedUrls,
        Categories:Categ
      });
  
      // Message de succès
      ResetForm();
      setMessage("Le produit a bien été mis à jour");
      document.querySelector('#ErrorDial').showModal();
  
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
      setMessage("Une erreur est survenue lors de la mise à jour.");
      document.querySelector('#ErrorDial').showModal();
    } finally {
      setloading(false);
    }
  };
  
  const ResetForm=async ()=>{
    /**Reset the form */
    setcurrentProduct(null)
    setidProduct(null)
    setProd(null)
    setImgVignette(null)
    document.querySelector('#Uploader').value=''
    setImgs(null)
    document.querySelectorAll('.delete').forEach(
      (elemnt)=>elemnt.classList.add('hide')
    )

    for (let index = 0; index < 4; index++) {
      
      document.querySelector(`#Img${index}`).value=''
      
    }
    setStarnumb(0)

    setCategories([])
    /**Reset the form */

  }


  useEffect(() => {

    if (loading) {

      document.querySelector('#Loading').showModal()
      
    } else {
      document.querySelector('#Loading').close()
      
    }

   
  }, [loading])


  useEffect(() => {
    if(Urls===null) return
    AddDoc('Produits',prod)
    setMessage('Votre produit a été bien ajouté')
    document.querySelector('#ErrorDial').showModal()

    ResetForm()

    

    
  }, [Urls])


  useEffect(() => {

    if (prod===null) return
    if (ImgVignette===null) return
    if (Imgs===null) return

    const Images=[ImgVignette,...Imgs]
    const Tab_Corrected=Images.filter((Image)=>{return Image!==undefined})
    setFiles(Tab_Corrected)
    //console.log(files)
    
    setproduit(prod)

   
  }, [prod,ImgVignette,Imgs])


  const readytosend = async(urls)=>{
 
   /* return new Promise ((resoluBien)=>{
      setUrls(urls)
      resoluBien(" C'est resolu avec "+ urls)
    })*/
   setUrls(urls)
   setloading(false)

  }

  const AjouterUnProduit = async ()=>{
    const DownloadUrls=[]

     
      const uploadFile = async () => {

       if(prod===null)  {
        setMessage("Aucune champ n'est ajouté")
        document.querySelector('#ErrorDial').showModal()
        return
      }   
       if(files==null) {
        
        setMessage("Aucune Image n'est ajouté")
        document.querySelector('#ErrorDial').showModal()
        return
      }

        setloading(true); 

       

        Promise.all(
          [...files].map(img => {
            return new Promise((resolu)=>{

              const imageRef = ref(storage, `Produits/${prod.Nom}/${prod.Nom + v4()}`);
              uploadBytes(imageRef, img).then((snapshot) => {
                getDownloadURL(snapshot.ref).then((url) => {
                  resolu(url)
                  DownloadUrls.push(url)
                  })
                }
              )


            })
              }
          )
        ).then(toutlesresolution=>readytosend(toutlesresolution)).catch(err=>console.log("Erreur d'upload de fichiers",err))
      
      }


      uploadFile()
      AddProdDetail('UrlsImages',DownloadUrls)
      //setUrls(DownloadUrls)
      
      
  }

  const verificationVide = (e)=>{

      const valeur=e.currentTarget.value

      const Regex_InputText= new RegExp(/^[a-zA-Z]{3,5}.*$/)
      const Regex_InputNumber= new RegExp(/^[0-9]{1,10}.*$/)
 
       
       /* Test de text */ 
       if (e.currentTarget.type==='text') {
        
       
       if(!Regex_InputText.test(valeur)) 
        {
          //console.log("Le champ "+ e.currentTarget.previousSibling.innerText + " doit etre rempli")
          e.currentTarget.classList.add('invalide')
          setajoutable(false)
        }
        else {
          //console.log(Regex_Input.test(e.currentTarget.value))
          e.currentTarget.classList.remove('invalide')
          setajoutable(true)
        }

      }
        /* Test de nombre */ 
      if (e.currentTarget.type==='number') {
        if(!Regex_InputNumber.test(valeur)) 
          {
            //console.log("Le champ "+ e.currentTarget.previousSibling.innerText + " doit etre rempli")
            e.currentTarget.classList.add('invalide')
            setajoutable(false)
          }
          else {
            //console.log(Regex_Input.test(e.currentTarget.value))
            e.currentTarget.classList.remove('invalide')
            setajoutable(true)
          }
        }   
      
      
  }

  return (
    <>

      <Notif Message={Message}/>
      <div className='flexH'style={{display:'none'}}> 
            <Pill bgcolor={"#transparent"} bordercolor={'#fff'} color={"#fff"} text={SKUcode} />
            {prod===null?'':<Pill bgcolor={"red"} bordercolor={'transparent'} color={"#fff"} text={'Supprimer ce produit'} classe={"FadeIn"}/>}
      </div>
      <div style={{display:'none'}} className="flexH">
        <SelectOption Label={'Catégorie'} options={Options4}/>
      </div>

        <div className="categories flexH">
            {
            Categ.map((categorie,index)=>{
              return (
                <span className="pillCategorie" key={index}>
                  <span>{categorie}</span>
                  
                  <span onClick={e=>setCategories([...Categories.filter((_,idx)=>{return idx!==index })])}>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">

                      <line x1="1.01363" y1="12.2373" x2="12.3273" y2="0.923559" stroke="white"/>
                      <line x1="1.72074" y1="0.875451" x2="13.0344" y2="12.1892" stroke="white"/>
                    </svg>

                  </span>
                  

                </span>
              )
            })
            }
            
        </div>

        <div className="flexH">
          <Field typeInput='text' requis={true} FieldName={'Categorie'} onchange={e=>setCategorie(e.currentTarget.value)} className={'normalInput'} onblur={e=>verificationVide(e)} value={Categorie}/>

          <Pill bgcolor={'#fff'} bordercolor={"transparent"} classe={''} color={'#000'} onclick={e=>{setCategories([...Categories,Categorie]); setCategorie('')}} text={'Ajouter une categorie +'} />
        </div>


      <Field FieldName={'Nom du produit'} requis={true} onchange={e=>AddProdDetail(['Nom'],e.currentTarget.value)} onblur={e=>verificationVide(e)} className={'normalInput'} value={prod===null?'': prod.Nom}/>

      <div id='text_descr'>
            <label htmlFor="textarea"  >Description {true && <span className='required'>*<span className='infobulle'>Champ obligatoire</span></span>}</label>
            <textarea name="" id="textarea"   onChange={e=>AddProdDetail(['Description'],e.currentTarget.value)} placeholder='Description de produit' value={prod===null?'': prod.Description} onBlur={e=>verificationVide(e)}></textarea>
      </div>
    

      <div className='flexH'>
          <Field typeInput='number' requis={true} FieldName={'Prix du Produit'} onchange={e=>AddProdDetail(['PrixInApp'],e.currentTarget.value)} value={prod===null?'':prod.PrixInApp} className={'smallInput'} onblur={e=>verificationVide(e)}/>

          <SelectOption Label={'Taux de promo'} value={prod===null?null:prod.TauxPromo} resetor={prod} options={Options4} onclick={value=>AddProdDetail(['TauxPromo'],value)}/>

          <Field typeInput='number' requis={true}  FieldName={'Stock'}  onchange={e=>AddProdDetail(['Stock'],e.currentTarget.value)} value={prod===null?'':prod.Stock} className={'smallInput'} onblur={e=>verificationVide(e)}/>
            
          {/*<Field typeInput='number'  requis={true} FieldName={'Rates'} onchange={e=>AddProdDetail(['Rates'],e.currentTarget.value)} value={prod===null?'':prod.Rates} className={'smallInput'} onblur={e=>verificationVide(e)} />*/}

            <div style={{alignSelf:'center',justifySelf:'center',fontWeight:'300'}}>
            <div style={{marginBottom:'0.5rem'}}>Rates</div>
            <Stars canMod={true} Rates={prod===null?starnumb:prod.Rates} onClick={e=>setRating(e)}/>
          </div>

      </div> 
  

      <div className='ChampExtra' style={{display:'none',flexDirection:'column',gap:'1rem'}}>

      
          <div className='flexH'>

              <SelectOption Label={'Selectionner la categorie :'} options={Options1} onclick={value=>AddProdDetail(['Categorie'],value)}/>
              <SelectOption Label={'Genre :'} options={Options2} onclick={value=>AddProdDetail(['Genre'],value)}/>
              <SelectOption Label={'Taille :'} options={Options3} onclick={value=>AddProdDetail(['Taille'],value)}/>
            
          </div>  


          <div>Couleurs</div>

          <div className='flexH ColorsPickerContainer'>
          
              <ColorPicker onclick={value=>AddProdDetail(['Color1'],value)}/>
              <ColorPicker/>
              <ColorPicker/>
              <ColorPicker/>

          </div> 
      </div>

      <div>

        <span style={{marginBottom:'1rem',fontWeight:'300',display:'block'}}>Images de produit</span>
       
        <div id='ZoneUploadeur'>

          <div id='ImageVignette'>
            <span>Image Vignette {true && <span className='required'>*<span className='infobulle'>Champ obligatoire</span></span>}</span>

            <div className='vign'>
             
                <div>
                <DeleteButton id={'DelVignette'} onClick={e=>DeleteVignette(e)}/>
                  <label id='ImgVignette' htmlFor='Uploader' vignette='true'>
                    <div>
                      <img src={ImgVignette===null?(currentProduct!==null&&currentProduct.UrlsImages[0]!==undefined)?currentProduct.UrlsImages[0]:PlaceHolderFile:URL.createObjectURL(ImgVignette)} alt={ImgVignette===null?'':ImgVignette.name}/>
                    </div>
                  </label>
                </div>
              
              <div style={{display:'flex',flexDirection:'column',gap:'1rem'}}>
                <div id='UploaderDiv'>
                  <input type="file" name="" id="Uploader" onChange={e=>UploadVignette(e,168,142)} accept='image/png, image/jpeg'/>
                </div>

                <div style={{display:'flex',flexDirection:'column'}}>
                  <span>
                    Format fichier :  L  = 168 px / H = 142 px
                  </span>
                  <span>
                    type de fichier :   .png ou .jpg
                  </span>
                </div>
              </div>

            </div>

          </div>


          <div id='Images'>

            <span>
              Image(s)  produit {true && <span className='required'>*<span className='infobulle'>Champ obligatoire</span></span>}
            </span>
        {/** */}
            <div id='RosterImg' className='flexH'>

              <div className='ImgsRoster'>
              <DeleteButton onClick={e=>DeletePicture(e,0)}/>
                <label htmlFor="Img0">
                  <div id='Img0div'><img src={Imgs===null||Imgs[0]===undefined?(currentProduct!==null&&currentProduct.UrlsImages[1]!==undefined)?currentProduct.UrlsImages[1]:PlaceHolderFile:URL.createObjectURL(Imgs[0])} alt={Imgs===null||Imgs[0]===undefined?'':Imgs[0].name}/></div>
                </label>
                <input type="file" name="" id="Img0"  onChange={e=>UpdateImgs(0,e,390,462)} accept='image/gif, image/png, image/jpeg,image/webp, image/avif'/>
              </div>
            
              <div className='ImgsRoster'>
              <DeleteButton onClick={e=>DeletePicture(e,1)}/>
                <label htmlFor="Img1" >
                  <div id='Img1div'><img src={Imgs===null||Imgs[1]===undefined?(currentProduct!==null&&currentProduct.UrlsImages[2]!==undefined)?currentProduct.UrlsImages[2]:PlaceHolderFile:URL.createObjectURL(Imgs[1])} alt={Imgs===null||Imgs[1]===undefined?'':Imgs[1].name}/></div>
                </label>
                <input type="file" name="" id="Img1"  onChange={e=>UpdateImgs(1,e,390,462)} accept='image/gif, image/png, image/jpeg,image/webp, image/avif'/>
              </div>
          
              <div className='ImgsRoster'>
              <DeleteButton onClick={e=>DeletePicture(e,2)}/>
                <label htmlFor="Img2" >
                  <div id='Img2div'><img src={Imgs===null||Imgs[2]===undefined?(currentProduct!==null&&currentProduct.UrlsImages[3]!==undefined)?currentProduct.UrlsImages[3]:PlaceHolderFile:URL.createObjectURL(Imgs[2])} alt={Imgs===null||Imgs[2]===undefined?'':Imgs[2].name}/></div>
                </label>
                <input type="file" name="" id="Img2"  onChange={e=>UpdateImgs(2,e,390,462)} accept='image/gif, image/png, image/jpeg,image/webp, image/avif'/>
              </div>
          
              <div className='ImgsRoster'>
              <DeleteButton onClick={e=>DeletePicture(e,3)}/>
                <label htmlFor="Img3" >
                  <div id='Img3div'><img src={Imgs===null||Imgs[3]===undefined?(currentProduct!==null&&currentProduct.UrlsImages[4]!==undefined)?currentProduct.UrlsImages[4]:PlaceHolderFile:URL.createObjectURL(Imgs[3])} alt={Imgs===null||Imgs[3]===undefined?'':Imgs[3].name}/></div>
                </label>
                <input type="file" name="" id="Img3" onChange={e=>UpdateImgs(3,e,390,462)} accept='image/gif, image/png, image/jpeg,image/webp, image/avif'/>
              </div>

            </div>
         
            <div style={{display:'flex',gap:'1rem'}}>

              {/**<div id='UploaderDiv2'>
                <label htmlFor="Uploader2" >Choisir les fichiers</label>
                <input type="file" name="ImagesUplodeur" id="Uploader2" multiple onChange={e=>BatchUpload(e,390,462)} accept='image/gif, image/png, image/jpeg,image/webp, image/avif' />
              </div> */}

              <div style={{display:'flex',flexDirection:'column'}}>

                <span>
                  Format fichier :  L  = 390 px / H = 462 px
                </span>
                <span>
                  type de fichier :   .png ou .jpg
                </span>

              </div>

            </div>

          </div>

        </div>

      </div> 



      <div id="Action">
                       { currentProduct===null?<Pill text={"Ajoutez un produit"} color={"#000"} bgcolor={"#E8C133"} bordercolor={"transparent"} classe={"btn"} onclick={AddtoTheDatabase}/>:
                       <Pill text={"Mettre a jour un produit"} color={"#000"} bgcolor={"#E8C133"} bordercolor={"transparent"} classe={"btn"} onclick={UpdatetoTheDatabase}/>
                        }
                        
                      
                        <Pill text={"Voir les autres produits"} color={"#fff"} bgcolor={"transparent"} bordercolor={"#e8c133"} classe={"btn"} onclick={ProductsList}/>
      </div>

      

    </>
  )

  
}



export default Form